/*
    here we "color" inputs that represent colors in the order form.
    we can't add inline styles to inputs because they will reset after click on submission button.
    and using elements' attributes in css is not supported.
    so that's why we create new style tag add styles for each color input individually.

    this scripts runs on the frontend and in the admin panel, so we need to check if we are in the admin panel
    and if we are, we need to wait for the page to load before we start adding styles.
*/

const style = document.createElement( 'style' );
document.head.appendChild( style );

function addColorClasses() {
    document.querySelectorAll( '.splitkon-colors-input .gfield-choice-input[value^="#"]' )?.forEach( input => {
        style.innerHTML += `.gform_wrapper .gfield-choice-input[value="${ input.value }"]{background-color: ${ input.value }}`;
    } );
}

document.addEventListener( 'DOMContentLoaded', () => {
    if ( document.body.classList.contains( 'wp-admin' ) ) {
        setTimeout( () => {
            addColorClasses();
        }, 3000 );
    } else {
        addColorClasses();
    }
} );
